import { render } from "./app.vue?vue&type=template&id=bcb8d84a&scoped=true"
import script from "./app.vue?vue&type=script&lang=ts"
export * from "./app.vue?vue&type=script&lang=ts"

import "./app.vue?vue&type=style&index=0&id=bcb8d84a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-bcb8d84a"

export default script